import { AdjustmentDeliveryNoteModelType } from '@teinor/erp/types/company/order/adjustmentDeliveryNote'
import { connect, ConnectedProps } from 'react-redux'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import InputTableLeftColumn, { InputTableLeftColumnCompleteRequiredProps } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn'
import ITHeaderText from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableTopHeader from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableTopHeader'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { InputWithLabelMargin } from '../../../../../../../../../../forms/Input'
import { useOrderITHeaderHandleChangeLogic } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/useOrderITHeaderHandleChange'
import { parseAddressToOneLine } from '../../../../../../../../../../utils/globals/address'
import { displayDate } from '../../../../../../../../../../utils/globals/date'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import useAdjustmentDeliveryNoteHeaderURLs from '../../../../../../../../../../utils/hooks/adjustmentDeliveryNote/useAdjustmentDeliveryNoteHeaderURLs'
import { ComponentTabObject } from '../../../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { getActiveCurrenciesDictionary } from '../../../../../../../../../../utils/reducers/getters'
import { ProductTypesPayload } from '../../../../../../../../../../utils/reducers/products/productTypes'
import AdjustmentReadOnlyHeaderMain from '../../../../header/AdjustmentReadOnlyHeaderMain'

type AdjustmentDeliveryNoteFinishedStepITHeaderProps = InputTableLeftColumnCompleteRequiredProps & ReduxAdjustmentDeliveryNoteFinishedStepITHeader & {}

const AdjustmentDeliveryNoteFinishedStepITHeader: React.FC<AdjustmentDeliveryNoteFinishedStepITHeaderProps> = ({ ...rest }) => {
    return <AppStyleDecider DefaultComponent={AdjustmentDeliveryNoteFinishedStepITHeaderDefault} NewComponent={AdjustmentDeliveryNoteFinishedStepITHeaderNew} {...rest} />
}

const AdjustmentDeliveryNoteFinishedStepITHeaderDefault: React.FC<AdjustmentDeliveryNoteFinishedStepITHeaderProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useAdjustmentDeliveryNoteHeaderURLs()
    const tabs: ComponentTabObject = {
        'main': {
            component: AdjustmentReadOnlyHeaderMain,
            text: t('dataDeliveryNote', 'Datos del albarán'), 
            extraProps: { orderHeaderURLs }
        },
    }
    return (
        <InputTableLeftColumn tabs={tabs} {...rest} />
    )
}

const AdjustmentDeliveryNoteFinishedStepITHeaderNew: React.FC<AdjustmentDeliveryNoteFinishedStepITHeaderProps> = ({ headerData, setCompleteData, updateDataURL, getCompleteData }) => {
    const { t } = useTwinTranslation()
    const { handleChange } = useOrderITHeaderHandleChangeLogic({ setCompleteData, updateDataURL })
    const activeCurrencies = getActiveCurrenciesDictionary()

    const sections: FormRender<AdjustmentDeliveryNoteModelType> = [
        {
            cols: 7,
            className: 'gap-x-20',
            elements: [
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: (props) => {
                        return <InputWithLabelMargin name='custom_name' label={t('customName', 'Nombre personalizado')} onChange={props.onChange} defaultValue={headerData?.custom_name} className='custom_name_input_field' />
                    }
                },
                {
                    name: 'processed_date',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('dateAdjustmentOrder', 'Fecha de la compra')} value={value ? displayDate(new Date(value)) : ''} />
                },
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('representative', 'Representante')} value={headerData?.RepresentativeEmployee?.fullname_short} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('assignedNumber', 'Nº asignado')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA')} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('billedBy', 'Facturado por')} value={headerData?.BillingWorkingCenter?.name || ''} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} />
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'WorkingCenterId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('adjustmentedBy', 'Comprado por')} value={headerData?.WorkingCenter.name || ''} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'WarehouseId',
                    component: 'Custom',
                    render: () => <ITHeaderText label={t('warehouse', 'Almacen')} value={headerData?.Warehouse?.name || ''} />,
                },
                {
                    name: 'BillingAddressId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('workingCenterAddress', 'Dirección centro de trabajo')} value={parseAddressToOneLine(headerData?.BillingWorkingCenter)
                        } />
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('currency', 'Moneda')} value={activeCurrencies?.[value]?.name} />,
                    hideSectionByDefault: true
                },
            ]
        }
    ]

    return (
        <InputTableTopHeader handleChange={handleChange} sections={sections} headerData={headerData} getCompleteData={getCompleteData} />
    )
}

const AdjustmentDeliveryNoteFinishedStepITHeaderDispatch = {
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}

export type ReduxAdjustmentDeliveryNoteFinishedStepITHeader = ConnectedProps<typeof adjustmentDeliveryNoteFinishedStepITHeaderConnect>
const mapAdjustmentDeliveryNoteFinishedStepITHeaderConnector = (state: AllReduxPayloads) => ({ productTypes: state.productTypes })
const adjustmentDeliveryNoteFinishedStepITHeaderConnect = connect(mapAdjustmentDeliveryNoteFinishedStepITHeaderConnector, AdjustmentDeliveryNoteFinishedStepITHeaderDispatch)
const AdjustmentDeliveryNoteFinishedStepITHeaderConnectLoading = withLoading(AdjustmentDeliveryNoteFinishedStepITHeader, [{ fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' }])
const AdjustmentDeliveryNoteFinishedStepITHeaderConnect = adjustmentDeliveryNoteFinishedStepITHeaderConnect(AdjustmentDeliveryNoteFinishedStepITHeaderConnectLoading)

export default AdjustmentDeliveryNoteFinishedStepITHeaderConnect